import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      light: "#64b5f6",
      main: "#1e88e5",
      dark: "#1565c0",
      200: "#90caf9",
      800: "#1565c0",
    },
    secondary: {
      light: "#ff80ab",
      main: "#ff4081",
      dark: "#c51162",
      200: "#f48fb1",
      800: "#ad1457",
    },
    error: {
      light: "#ef5350",
      main: "#f44336",
      dark: "#d32f2f",
    },
    orange: {
      light: "#ffb74d",
      main: "#ff9800",
      dark: "#f57c00",
    },
    warning: {
      light: "#ffb74d",
      main: "#ff9800",
      dark: "#f57c00",
    },
    success: {
      light: "#81c784",
      200: "#a5d6a7",
      main: "#4caf50",
      dark: "#388e3c",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f5",
      500: "#9e9e9e",
      600: "#757575",
      700: "#616161",
      900: "#212121",
    },
    dark: {
      light: "#484848",
      main: "#212121",
      dark: "#000000",
      800: "#303030",
      900: "#424242",
    },
    text: {
      primary: "#ffffff",
      secondary: "#b0bec5",
      dark: "#000000",
      hint: "#e0e0e0",
    },
    background: {
      paper: "#1e1e2f",
      default: "#0e0e16",
    },
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
    fontSize: 17,
  },
});

export default theme;
